export default __webpack_public_path__ + "static/media/Background 5_00056.56c9bf07.png";